export const candidatesReducer = (state = {loading: true, resultcandidate: null, candidates: null, candidate: null, candidateuser: null, candidatesprovinces: null, candidateStatus: null, levels: [], subjects: [], titles: [], candidateTowns: [] } , action) => {
    switch (action.type) {
        case 'CANDIDATE_GETALL_SUCCESS':
            return {
                ...state,
                loading:false,
                candidates: action.payload
            }
        case 'CANDIDATE_GETPROVINCES_SUCCESS':
            return {
                ...state,
                loading:false,
                candidatesprovinces: action.payload
            }
        case 'CANDIDATE_GET_SUCCESS':
            return {
                ...state,
                loading:false,
                candidate: action.payload.candidate,
                candidateuser: action.payload.candidateuser
            }
        case 'CANDIDATE_ACTIVATEDEACTIVATE_SUCCESS':
            return {
                ...state,
                loading:false,
                candidateuser: {...state.candidateuser, active: action.payload.activeStatus}
            }
        case 'CANDIDATE_ADD_SUCCESS':
            return {
                ...state,
                loading:false,
                resultcandidate: action.payload
            }
        case 'CANDIDATE_ADDSCHOOL_SUCCESS':
            return {
                ...state,
                candidates: state.candidates?.map(candidatePercentage => {
                    return {...candidatePercentage, candidates: candidatePercentage?.candidates?.map(candidateAvailable => {
                        if (candidateAvailable.id === action.payload.id) {
                            candidateAvailable.firstname = action.payload.firstname
                            candidateAvailable.lastname = action.payload.lastname
                            candidateAvailable.phone = action.payload.phone
                            candidateAvailable.email = action.payload.email
                            candidateAvailable.bought = action.payload.bought
    
                            return candidateAvailable
                        } else {
                            return candidateAvailable
                        }
                    })}
    
                })
            }
        case 'CANDIDATE_UPDATE_SUCCESS':
            return {
                ...state,
                loading:false,
                resultcandidate: action.payload
            }
        case 'CANDIDATE_REMOVE_SUCCESS':
            return {
                ...state,
                loading:false,
                resultcandidate: action.payload
            }
        case 'CANDIDATE_DOCUMENT_SEND_SUCCESS':
            return {
                ...state,
                loading:false,
                resultcandidate: action.payload
            }
        case 'CANDIDATE_REPORT_SUCCESS':
            return {
                ...state,
                loading:false,
                resultcandidate: action.payload
            }
        case 'CANDIDATE_DOCUMENT_DELETE_SUCCESS':
            return {
                ...state,
                loading:false,
                resultcandidate: action.payload
            }
        case 'CANDIDATE_RESET_RESULT':
            return {...state,
                resultcandidate: null
            }
        case 'CANDIDATE_LOADING':
            return {
                ...state,
                loading:true
            }
        case 'CANDIDATE_NOT_LOADING':
            return {
                ...state,
                loading:false
            }
        case 'CANDIDATE_EDIT_COMPETENCES_SUCCESS':
            return {
                ...state,
                loading: false,
                resultcandidate: action.payload
            }
        case 'CANDIDATE_EDIT_METHOLDOLOGIES_SUCCESS':
            return {
                ...state,
                loading: false,
                resultcandidate: action.payload
            }
        case 'CANDIDATE_EDIT_TECHNOLOGIES_SUCCESS':
            return {
                ...state,
                loading: false,
                resultcandidate: action.payload
            }
        case 'CANDIDATE_GET_STATUS_SUCCESS':
            return {
                ...state,
                loading: false,
                candidateStatus: action.payload
            }
        case 'CANDIDATE_GET_LEVELS_SUCCESS':
            return {
                ...state,
                loading: false,
                levels: action.payload
            }
        case 'CANDIDATE_GET_SUBJECTS_SUCCESS':
            return {
                ...state,
                loading: false,
                subjects: action.payload
            }
        case 'CANDIDATE_RESET_SUBJECTS':
            return {
                ...state,
                loading: false,
                subjects: []
            }
        case 'CANDIDATE_RESET_LEVELS':
            return {
                ...state,
                loading: false,
                levels: []
            }
        case 'CANDIDATE_GET_TITLES_SUCCESS':
            return {
                ...state,
                loading: false,
                titles: action.payload
            }
        case 'CANDIDATE_GET_TOWNS_SUCCESS':
            return {
                ...state,
                loading: false,
                candidateTowns: action.payload
            }
        default:
            return state
    }
}

